import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is VTS really free?",
    a: "Yes — 100% free. There is no subscription, no signup fee and no hidden charge. Every bot, the Pro Trade desk, the signals and the full Arcade are free to use. All you need is a free Deriv account, and you only ever risk the stakes you choose to trade.",
  },
  {
    q: "Is VTS a broker?",
    a: "No. VTS is a trading interface built on top of Deriv's official API. We are an introducing partner — your trading account, funds and contract execution all happen through Deriv, a regulated broker.",
  },
  {
    q: "Do I need a Deriv account?",
    a: "Yes — but you can create one in under 60 seconds. Click 'Start Trading', complete the Deriv signup, and you'll be redirected back to VTS ready to go. A free demo account is created automatically.",
  },
  {
    q: "What does it cost?",
    a: "Nothing — VTS is completely free, and opening a Deriv account is free too. You only pay the contract stakes you choose to trade. Payouts are shown transparently on every contract before you confirm.",
  },
  {
    q: "What markets can I trade?",
    a: "All Deriv-supported markets: Synthetic Indices (Volatility 10/25/50/75/100, Crash, Boom), Forex (50+ pairs), Cryptocurrencies (BTC, ETH, etc.), and Commodities (Gold, Silver, Oil).",
  },
  {
    q: "Is my data safe?",
    a: "Authentication happens through Deriv's OAuth. We never see or store your password. Trading tokens stay in your browser session and are cleared on logout.",
  },
  {
    q: "Can I use a demo account first?",
    a: "Absolutely. New Deriv accounts come with USD 10,000 virtual demo funds. Practice as long as you want before switching to a real account.",
  },
  {
    q: "How do the trading bots work?",
    a: "The Auto Bot runs 103 Rise/Fall strategies 24/7 on our servers and only trades the ones that pass live accreditation. The Over 3 Quick Bot trades digit contracts with an optional stake-adjust system. Both keep running with your phone off. Like all trading, results are never guaranteed — built-in loss limits help protect your balance.",
  },
  {
    q: "What is copy trading on VTS?",
    a: "Follow the desk's Pro Trades and have them mirrored to your account automatically, with your own stake sizing. You stay in control and can unfollow at any time.",
  },
];

const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 lg:py-32 border-t border-vts-line"
    >
      <div className="mx-auto max-w-4xl px-5 lg:px-8">
        <div className="mb-14">
          <div className="text-xs uppercase tracking-[0.25em] text-vts-blue font-semibold mb-4">
            06 — Common questions
          </div>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl text-white tracking-tighter">
            Everything you<br />
            <span className="text-vts-silver">need to know.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`faq-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="border border-vts-line rounded-md bg-vts-surface px-5 hover:border-vts-silver/30 transition"
            >
              <AccordionTrigger className="text-left text-white font-heading font-medium text-base py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-vts-silver/80 font-body text-sm pb-5 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
